import request from '@/utils/request'

//发票列表
export function invoiceList(data) {
  return request({
    url: 'api/v1/invoice/invoiceList',
    method: 'post',
    data
  })
}
//开发票
export function openInvoice(data) {
  return request({
    url: 'api/v1/invoice/openInvoice',
    method: 'post',
    data
  })
}
//作废发票
export function cancelInvoice(data) {
  return request({
    url: 'api/v1/invoice/cancelInvoice',
    method: 'post',
    data
  })
}